import { render, staticRenderFns } from "./huituoOrder.vue?vue&type=template&id=b0a688a8&scoped=true&"
import script from "./huituoOrder.vue?vue&type=script&lang=js&"
export * from "./huituoOrder.vue?vue&type=script&lang=js&"
import style0 from "./huituoOrder.vue?vue&type=style&index=0&id=b0a688a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a688a8",
  null
  
)

export default component.exports